import React from 'react';
import classNames from 'classnames';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { FormChangesUI } from '@praktio/common-ui';

import './PageHeader.scss';

interface IProps {
  pageName: string;
  children?: React.ReactNode;
  savedChanges?: boolean;
  unsavedChanges?: boolean;
  subtitle?: string;
  logo?: File | string;
  isCourseInfoPage?: boolean;
  courseComplete?: boolean;
  className?: string;
  subpage?: boolean;
}

const PageHeader = ({
  pageName,
  children,
  savedChanges,
  unsavedChanges,
  subtitle,
  logo,
  isCourseInfoPage,
  courseComplete,
  className,
  subpage,
}: IProps) => {
  return (
    <Container
      fluid
      className={classNames(
        'PageHeader sticky-top d-flex align-items-center',
        isCourseInfoPage ? 'px-lg-4' : 'px-lg-5',
        className,
        {},
      )}
    >
      <Row className="ml-0 mr-0 w-100">
        <Col className="d-flex justify-content-between">
          <div className="PageHeader-left-content d-flex">
            {isCourseInfoPage && (
              <div className="PageHeader-icon">
                <img
                  src={(logo as string) || '/course-library-default.png'}
                  alt=""
                  aria-hidden="true"
                />
              </div>
            )}
            <div className="PageHeader-name-and-subtitle d-flex flex-column justify-content-center">
              <div className="PageHeader-name-and-complete-badge d-flex align-items-center">
                <h1 className="PageHeader-name">{pageName}</h1>
              </div>
              {subtitle && <div className="PageHeader-subtitle">{subtitle}</div>}
            </div>
          </div>
          <FormChangesUI
            unsavedChanges={unsavedChanges}
            savedChanges={savedChanges}
            children={children}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default PageHeader;
